import { forwardRef } from 'react'

import Flex, { FlexProps } from './Flex'

type Props = Omit<FlexProps, 'direction'>
const HStack = forwardRef<HTMLDivElement, Props>((props, ref) => (
  <Flex direction="row" align="center" {...props} ref={ref} />
))

export default HStack
